import React, { useEffect, useState } from "react";
import {
  Box,
  CircularProgress,
  FormHelperText,
  makeStyles,
  MenuItem,
} from "@material-ui/core";
import moment from "moment";
import voca from "voca";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import { useIntl } from "react-intl";
import { FormattedMessage } from "react-intl";
import InputAdornment from "@material-ui/core/InputAdornment";
import IconButton from "@material-ui/core/IconButton";
import InsertInvitationIcon from "@material-ui/icons/InsertInvitation";
import LocationOnIcon from "@material-ui/icons/LocationOn";
import Modal from "@material-ui/core/Modal";
import * as Yup from "yup";

import { InputButton } from "../../../../../../components/input-button/InputButton";
import { InputField } from "../../../../../../components/input-field/InputField";
import { ViewDocumentInput } from "../../../../../../components/view_document_input/ViewDocumentInput";
import {
  DDDD_MMMM_YYYY_FORMAT,
  FILE_MAX_SIZE,
  FILE_MAX_SIZE_STR,
  YYYY_MM_DD_FORMAT,
} from "../../../../../../settings/constants";
import { FormikHelpers, useFormik } from "formik";
import { IoIosCalendar, IoIosPin } from "react-icons/io";
import { InputDate } from "../../../../../../components/input-date/InputDate";
import { InputSelect } from "../../../../../../components/input-select/InputSelect";
import BusinessCategoryService from "../../../../../../services/BusinessCategoryService";
import BusinessCategory from "../../../../../../models/BusinessCategory";
import { PhoneNumberInput } from "../../../../../../components/phone-number/PhoneNumberInput";
import {
  base64,
  formatPhoneNumber,
  validateFile,
} from "../../../../../../common/Hooks";
import Country from "../../../../../../models/Country";
import { PhoneNumber } from "libphonenumber-js/types";
import { ImageChooser } from "../../../../../../components/image-chooser/ImageChooser";
import BusinessService from "../../../../../../services/BusinessService";
import {
  useAuthenticationContext,
  UserActionTypeEnum,
} from "../../../../../../context/UserContext";

interface OverviewProps {
  id: number;
  companyName: string;
  startDate: string;
  address: string;
  registrationNumber: string;
  taxPayerNumber: string;
  ribNumber: string;
  bicNumber: string;
  registration: string;
  taxPapers: string;
  bankAccount: string;
  companyLogo: string;
  primaryPhoneNumber: string;
  country: any;
  email: string;
  categoryId: number;

  callback: Function;
}

const useStyles = makeStyles((theme) => ({
  main: {
    width: "100%",
    height: "100%",
    flexGrow: 1,
  },
  formSectionTitle: {
    fontWeight: 400,
    fontSize: 24,
  },
  spacer: {
    width: "100%",
    height: 40,
  },
  inputDocumentInfo: {
    fontSize: 17,
    color: theme.palette.primary.light,
  },
  deleteNotice: {
    fontSize: 17,
    color: theme.palette.grey[400],
  },
  deleteButton: {
    fontSize: 17,
    backgroundColor: "#FF2929",
    color: "#FFFFFF",
    textTransform: "none",
  },
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  zoomed: {
    width: "60vw",
    height: "70vh",
  },
  formWrapper: {
    // border: "1px solid red",
    padding: "30px 0",
  },
}));

export const Overview = (props: OverviewProps) => {
  const classes = useStyles();
  const { formatMessage } = useIntl();
  const intl = useIntl();
  const {
    id,
    companyName,
    startDate,
    address,
    registrationNumber,
    taxPayerNumber,
    ribNumber,
    bicNumber,
    registration,
    taxPapers,
    bankAccount,
    companyLogo,
    country,
    categoryId,
    email,
    primaryPhoneNumber,
    callback,
  } = props;
  const [zoomImage, setZoomImage] = useState(null);
  const [zoomed, setZoomed] = useState(false);
  const [editing, setEditing] = useState(false);
  const [businessCategories, setBusinessCategories] = useState(
    (): Array<BusinessCategory> => null
  );
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [user, token, authDispatch] = useAuthenticationContext();

  const loadBusinessCategories = () => {
    const response = BusinessCategoryService.supportedBusinessCategories();

    response.then((response) => {
      let results: Array<BusinessCategory> = [];

      if (response.isSuccess && response.data.code === 100) {
        JSON.parse(JSON.stringify(response.data.data)).forEach(
          (item, index) => {
            results.push(BusinessCategory.fromJson(item));
          }
        );
        setBusinessCategories(results);
      } else {
        setBusinessCategories([]);
      }
    });
  };

  const viewDocument = (image: string) => {
    setZoomImage(image);
    setZoomed(true);
  };

  const renderContent = () => {
    return (
      <>
        <Grid item xs={12} sm={12} lg={12}>
          <InputField
            value={companyName}
            label={formatMessage({ id: "sharedScreen.companyName" })}
            fullWidth
            readOnly={true}
          />
        </Grid>
        <Grid item xs={12} sm={12} lg={12}>
          <InputField
            value={voca.titleCase(
              moment(startDate).format(DDDD_MMMM_YYYY_FORMAT)
            )}
            label={formatMessage({ id: "sharedScreen.startDate" })}
            fullWidth
            readOnly={true}
            endAdornment={
              <InputAdornment position="end">
                <IconButton edge="end">
                  <InsertInvitationIcon />
                </IconButton>
              </InputAdornment>
            }
          />
        </Grid>
        <Grid item xs={12} sm={12} lg={12}>
          <InputField
            value={address}
            label={formatMessage({ id: "sharedScreen.address" })}
            fullWidth
            readOnly={true}
            endAdornment={
              <InputAdornment position="end">
                <IconButton edge="end">
                  <LocationOnIcon />
                </IconButton>
              </InputAdornment>
            }
          />
        </Grid>
        <Grid item xs={12} sm={12} lg={12}>
          <InputField
            value={registrationNumber}
            label={formatMessage({ id: "sharedScreen.registrationNumber" })}
            fullWidth
            readOnly={true}
          />
        </Grid>
        <Grid item xs={12} sm={12} lg={12}>
          <InputField
            value={taxPayerNumber}
            label={formatMessage({ id: "sharedScreen.taxPayerNumber" })}
            fullWidth
            readOnly={true}
          />
        </Grid>
        <Grid item xs={12} sm={12} lg={12}>
          <InputField
            value={ribNumber}
            label={formatMessage({ id: "sharedScreen.ribNumber" })}
            fullWidth
            readOnly={true}
          />
        </Grid>
        <Grid item xs={12} sm={12} lg={12}>
          <InputField
            value={bicNumber}
            label={formatMessage({ id: "sharedScreen.bicNumber" })}
            fullWidth
            readOnly={true}
          />
        </Grid>
        <Grid item xs={12} sm={12} lg={12} />
        <Grid item xs={12} sm={12} lg={12}>
          <Typography
            className={classes.formSectionTitle}
            variant="h4"
            component="h4"
          >
            <FormattedMessage id="sharedScreen.myDocuments" />
          </Typography>
        </Grid>
        <ViewDocumentInput
          label={formatMessage({ id: "sharedScreen.tradeRegistry" })}
          viewCallback={() => viewDocument(registration)}
          selectCallback={null}
        />
        <ViewDocumentInput
          label={formatMessage({ id: "sharedScreen.taxPapers" })}
          viewCallback={() => viewDocument(taxPapers)}
          selectCallback={null}
        />
        <ViewDocumentInput
          label={formatMessage({ id: "sharedScreen.bankAccount" })}
          viewCallback={() => viewDocument(bankAccount)}
          selectCallback={null}
        />
        <ViewDocumentInput
          label={formatMessage({ id: "sharedScreen.companyLogo" })}
          viewCallback={() => viewDocument(companyLogo)}
          selectCallback={null}
        />
        <Grid item xs={12} sm={12} lg={12}>
          <div className={classes.spacer} />
        </Grid>
        <Grid item container xs={12} sm={12} lg={12} justify="center">
          <Typography
            className={classes.deleteNotice}
            variant="h4"
            component="h4"
          >
            <FormattedMessage id="sharedScreen.deleteBusinessNotice" />
          </Typography>
        </Grid>
        <Grid item container xs={12} sm={12} lg={12} justify="center">
          <InputButton className={classes.deleteButton} disabled>
            <FormattedMessage id="sharedScreen.deleteAccount" />
          </InputButton>
        </Grid>
        <Grid item xs={12} sm={12} lg={12}>
          <div className={classes.spacer} />
        </Grid>
      </>
    );
  };

  const handleDateChange = (name: string, dateString: string) => {
    formik.setValues({ ...formik.values, [name]: dateString });
  };

  const initPrimaryCountry = () => {
    return country !== null ? country : Country.defaultCountry("");
  };

  const handlePhoneChange = (phoneNumber: PhoneNumber | null) => {
    if (phoneNumber !== null) {
      formik.values.primary_phone_number = phoneNumber.number.toString();
      formik.values.primary_phone_number_dial_code = `+${phoneNumber.countryCallingCode}`;
      formik.values.primary_phone_number_iso_code = phoneNumber.country
        .toString()
        .toUpperCase();

      if (!phoneNumber.isValid()) {
        formik.setErrors({
          ...formik.errors,
          primary_phone_number: intl.formatMessage({
            id: "error.invalidPhoneNumber",
          }),
        });
      } else {
        formik.setErrors({ ...formik.errors, primary_phone_number: undefined });
      }
    } else {
      formik.values.primary_phone_number = "";
      formik.setErrors({ ...formik.errors, primary_phone_number: undefined });
    }
  };

  const initFormValues = () => {
    return {
      primary_phone_number_dial_code: country.dial_code,
      primary_phone_number_iso_code: country.iso_code,
      primary_phone_number: formatPhoneNumber(`${country.iso_code}${primaryPhoneNumber}`, true),
      business_category_id: categoryId,
      company_name: companyName,
      company_email: email,
      start_date: startDate,
      company_address: address,
      registration_number: registrationNumber,
      tax_payer_number: taxPayerNumber,
      rib_number: ribNumber,
      bic_number: bicNumber,
      registration_photo: registration,
      tax_payer_photo: taxPapers,
      id_bank_photo: bankAccount,
      company_logo: companyLogo,
    };
  };

  const handleAttachmentSelection = (name: string, file: File) => {
    if (file !== null) {
      base64(file, (result) => {
        formik.values[name] = result;
      });
    } else {
      formik.values[name] = null;
    }
    formik.setErrors({ ...formik.errors, [name]: undefined });
  };

  const genericError = () => {
    if (formik.errors.unknown) {
      return formik.errors.unknown as string;
    }

    return "";
  };

  const formValidation = () => {
    return {
      business_category_id: Yup.number().required(
        intl.formatMessage({ id: "error.categoryCompany" })
      ),
      company_name: Yup.string()
        .max(100, intl.formatMessage({ id: "error.tooLong" }))
        .required(intl.formatMessage({ id: "error.companyName" })),
      company_email: Yup.string()
        .email(intl.formatMessage({ id: "error.email" }))
        .required(intl.formatMessage({ id: "error.email" })),
      primary_phone_number: Yup.string().required(
        intl.formatMessage({ id: "error.invalidPhoneNumber" })
      ),
      start_date: Yup.string().required(
        intl.formatMessage({ id: "error.startDate" })
      ),
      company_address: Yup.string().required(
        intl.formatMessage({ id: "error.companyAddress" })
      ),
      registration_number: Yup.string()
        .max(100, intl.formatMessage({ id: "error.tooLong" }))
        .required(intl.formatMessage({ id: "error.enterValidRegNum" })),
      tax_payer_number: Yup.string()
        .max(100, intl.formatMessage({ id: "error.tooLong" }))
        .required(intl.formatMessage({ id: "error.enterValidTaxNum" })),
      bic_number: Yup.string()
        .max(100, intl.formatMessage({ id: "error.tooLong" }))
        .required(intl.formatMessage({ id: "error.enterValidBicNum" })),
      rib_number: Yup.string()
        .max(100, intl.formatMessage({ id: "error.tooLong" }))
        .required(intl.formatMessage({ id: "error.enterValidRibNum" })),

      company_logo: Yup.mixed()
        .required(intl.formatMessage({ id: "error.selectValidPhoto" }))
        .test(
          "fileSize",
          intl.formatMessage(
            { id: "error.tooLargePicture" },
            { max: FILE_MAX_SIZE_STR }
          ),
          (value) => {
            if(typeof(value) === typeof("")) return true;
            return value !== null && validateFile(value, FILE_MAX_SIZE);
          }
        ),
      id_bank_photo: Yup.mixed()
        .required(intl.formatMessage({ id: "error.selectValidPhoto" }))
        .test(
          "fileSize",
          intl.formatMessage(
            { id: "error.tooLargePicture" },
            { max: FILE_MAX_SIZE_STR }
          ),
          (value) => {
            if(typeof(value) === typeof("")) return true;
            return value !== null && validateFile(value, FILE_MAX_SIZE);
          }
        ),
      registration_photo: Yup.mixed()
        .required(intl.formatMessage({ id: "error.selectValidPhoto" }))
        .test(
          "fileSize",
          intl.formatMessage(
            { id: "error.tooLargePicture" },
            { max: FILE_MAX_SIZE_STR }
          ),
          (value) => {
            if(typeof(value) === typeof("")) return true;
            return value !== null && validateFile(value, FILE_MAX_SIZE);
          }
        ),
      tax_payer_photo: Yup.mixed()
        .required(intl.formatMessage({ id: "error.selectValidPhoto" }))
        .test(
          "fileSize",
          intl.formatMessage(
            { id: "error.tooLargePicture" },
            { max: FILE_MAX_SIZE_STR }
          ),
          (value) => {
            if(typeof(value) === typeof("")) return true;
            return value !== null && validateFile(value, FILE_MAX_SIZE);
          }
        ),
    };
  };

  const formik = useFormik({
    initialValues: initFormValues(),
    validationSchema: Yup.object().shape({
      ...formValidation(),
    }),
    onSubmit: async (
      values: any,
      { setErrors, setSubmitting }: FormikHelpers<any>
    ) => {
      try {
        const registration = await BusinessService.updateBusiness(id, values);
        if (registration.isSuccess) {
          switch (registration.data.code) {
            case 100: // Ok
              setEditing(false);
              authDispatch({
                type: UserActionTypeEnum.updateBusiness,
                data: JSON.parse(JSON.stringify(registration.data.data)),
              });
              callback();
              break;
            case 150:
              setErrors(JSON.parse(JSON.stringify(registration.data.data)));
              break;
            default:
              setErrors({ unknown: registration.data.message });
              break;
          }
          setSubmitting(false);
        } else {
          setSubmitting(false);
          setErrors({
            unknown: intl.formatMessage({ id: "sharedScreen.unknownError" }),
          });
        }
      } catch (error) {
        setSubmitting(false);
        setErrors({
          unknown: intl.formatMessage({ id: "sharedScreen.unknownError" }),
        });
      }
    },
  });

  const renderEditingContent = () => {
    return (
      <>
        <form
          noValidate
          autoComplete="off"
          style={{ width: "100%", marginBottom: "30px" }}
          onSubmit={formik.handleSubmit}
        >
          <Grid container spacing={2}>
            <Grid item sm={7} className={classes.formWrapper}>
              <Box ml={1} pr={5} mt={2} style={{ width: "100%" }}>
                <Box mb={2}>
                  <InputField
                    fullWidth
                    id="company_name"
                    name="company_name"
                    label={intl.formatMessage({
                      id: "sharedScreen.companyName",
                    })}
                    placeholder={intl.formatMessage({
                      id: "sharedScreen.enterCompanyName",
                    })}
                    type="text"
                    onChange={formik.handleChange}
                    value={formik.values.company_name}
                    error={
                      Boolean(formik.touched.company_name) &&
                      Boolean(formik.errors.company_name)
                    }
                    helperText={
                      formik.touched.company_name && formik.errors.company_name
                    }
                  />
                </Box>
                <Box mb={2}>
                  <PhoneNumberInput
                    id="primary_phone_number"
                    name="primary_phone_number"
                    label={intl.formatMessage({
                      id: "sharedScreen.phoneNumber",
                    })}
                    defaultCountry={initPrimaryCountry()}
                    defaultPhone={formatPhoneNumber(
                      formik.values.primary_phone_number,
                      false
                    )}
                    error={
                      formik.touched.primary_phone_number &&
                      formik.errors.primary_phone_number
                    }
                    onChange={handlePhoneChange}
                  />
                </Box>
                <Box mb={2}>
                  <InputSelect
                    fullWidth
                    id="business_category_id"
                    name="business_category_id"
                    label={intl.formatMessage({
                      id: "sharedScreen.businessCategory",
                    })}
                    value={formik.values.business_category_id}
                    onChange={formik.handleChange}
                    error={
                      Boolean(formik.touched.business_category_id) &&
                      Boolean(formik.errors.business_category_id)
                    }
                    helperText={
                      formik.touched.business_category_id &&
                      formik.errors.business_category_id
                    }
                  >
                    <MenuItem value="" disabled>
                      {businessCategories === null ? (
                        <FormattedMessage id="sharedScreen.loading" />
                      ) : (
                        <FormattedMessage id="sharedScreen.selectCategory" />
                      )}
                    </MenuItem>
                    {(businessCategories === null
                      ? []
                      : businessCategories
                    ).map((item, i) => (
                      <MenuItem key={i} value={item.id}>
                        {item.designation}
                      </MenuItem>
                    ))}
                  </InputSelect>
                </Box>
                <Box>
                  <InputField
                    fullWidth
                    id="company_email"
                    name="company_email"
                    label={intl.formatMessage({
                      id: "sharedScreen.email",
                    })}
                    placeholder={intl.formatMessage({
                      id: "sharedScreen.enterCompanyEmail",
                    })}
                    type="text"
                    onChange={formik.handleChange}
                    value={formik.values.company_email}
                    error={
                      Boolean(formik.touched.company_email) &&
                      Boolean(formik.errors.company_email)
                    }
                    helperText={
                      formik.touched.company_email &&
                      formik.errors.company_email
                    }
                  />
                </Box>
                <Box mt={2}>
                  <InputField
                    fullWidth
                    id="company_address"
                    name="company_address"
                    label={intl.formatMessage({
                      id: "sharedScreen.address",
                    })}
                    placeholder={intl.formatMessage({
                      id: "sharedScreen.companyAddress",
                    })}
                    type="text"
                    onChange={formik.handleChange}
                    value={formik.values.company_address}
                    error={
                      Boolean(formik.touched.company_address) &&
                      Boolean(formik.errors.company_address)
                    }
                    helperText={
                      formik.touched.company_address &&
                      formik.errors.company_address
                    }
                    endAdornment={
                      <InputAdornment position="end">
                        <IoIosPin />
                      </InputAdornment>
                    }
                  />
                </Box>
                <Box mt={2}>
                  <InputDate
                    maxDate={moment().format(YYYY_MM_DD_FORMAT)}
                    onDateChange={(name, date) => handleDateChange(name, date)}
                    inputProps={{
                      fullWidth: true,
                      id: "start_date",
                      name: "start_date",
                      label: intl.formatMessage({
                        id: "sharedScreen.startDate",
                      }),
                      placeholder: intl.formatMessage({
                        id: "sharedScreen.enterCompanyStartDate",
                      }),
                      endAdornment: (
                        <InputAdornment position="end">
                          <IoIosCalendar />
                        </InputAdornment>
                      ),

                      value: formik.values.start_date,
                      error:
                        Boolean(formik.touched.start_date) &&
                        Boolean(formik.errors.start_date),
                      helperText:
                        formik.touched.start_date && formik.errors.start_date,
                    }}
                    pickerProps={{
                      format: YYYY_MM_DD_FORMAT,
                      disabled: false,
                      showToday: false,
                    }}
                  />
                </Box>
                <Box
                  component="div"
                  mb={2}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    width: "100%",
                  }}
                >
                  <Box style={{ width: "100%" }}>
                    <InputField
                      fullWidth
                      id="registration_number"
                      name="registration_number"
                      label={intl.formatMessage({
                        id: "sharedScreen.regNum",
                      })}
                      placeholder={intl.formatMessage({
                        id: "sharedScreen.enterRegNum",
                      })}
                      type="text"
                      onChange={formik.handleChange}
                      value={formik.values.registration_number}
                      error={
                        Boolean(formik.touched.registration_number) &&
                        Boolean(formik.errors.registration_number)
                      }
                      helperText={
                        formik.touched.registration_number &&
                        formik.errors.registration_number
                      }
                    />
                  </Box>
                  <Box ml={1} style={{ width: "100%" }}>
                    <InputField
                      fullWidth
                      id="tax_payer_number"
                      name="tax_payer_number"
                      label={intl.formatMessage({
                        id: "sharedScreen.taxNum",
                      })}
                      placeholder={intl.formatMessage({
                        id: "sharedScreen.enterTaxNum",
                      })}
                      type="text"
                      onChange={formik.handleChange}
                      value={formik.values.tax_payer_number}
                      error={
                        Boolean(formik.touched.tax_payer_number) &&
                        Boolean(formik.errors.tax_payer_number)
                      }
                      helperText={
                        formik.touched.tax_payer_number &&
                        formik.errors.tax_payer_number
                      }
                    />
                  </Box>
                </Box>
                <Box
                  component="div"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    width: "100%",
                  }}
                >
                  <Box style={{ width: "100%" }}>
                    <InputField
                      fullWidth
                      id="rib_number"
                      name="rib_number"
                      label={intl.formatMessage({
                        id: "sharedScreen.ribNum",
                      })}
                      placeholder={intl.formatMessage({
                        id: "sharedScreen.enterRibNum",
                      })}
                      type="text"
                      onChange={formik.handleChange}
                      value={formik.values.rib_number}
                      error={
                        Boolean(formik.touched.rib_number) &&
                        Boolean(formik.errors.rib_number)
                      }
                      helperText={
                        formik.touched.rib_number && formik.errors.rib_number
                      }
                    />
                  </Box>
                  <Box ml={1} style={{ width: "100%" }}>
                    <InputField
                      fullWidth
                      id="bic_number"
                      name="bic_number"
                      label={intl.formatMessage({
                        id: "sharedScreen.bicNum",
                      })}
                      placeholder={intl.formatMessage({
                        id: "sharedScreen.enterBicNum",
                      })}
                      type="text"
                      onChange={formik.handleChange}
                      value={formik.values.bic_number}
                      error={
                        Boolean(formik.touched.bic_number) &&
                        Boolean(formik.errors.bic_number)
                      }
                      helperText={
                        formik.touched.bic_number && formik.errors.bic_number
                      }
                    />
                  </Box>
                </Box>
              </Box>
            </Grid>
            <Grid item sm={5} className={classes.formWrapper}>
              <Box ml={3} mr={2} mt={4}>
                <Box mb={2}>
                  <Box component="span" display="block" mb={1}>
                    <FormattedMessage id="sharedScreen.companyLogo" />
                  </Box>
                  <ImageChooser
                    variant="square"
                    defaultFile={companyLogo}
                    onImageSelected={(file) => {
                      handleAttachmentSelection("company_logo", file);
                    }}
                    label={intl.formatMessage({
                      id: "sharedScreen.addCompanyLogo",
                    })}
                  />
                  {formik.touched.company_logo &&
                    formik.errors.company_logo && (
                      <FormHelperText className="errorWrapper">
                        {formik.errors.company_logo}
                      </FormHelperText>
                    )}
                </Box>
                <Box mb={2}>
                  <Box component="span" display="block" mb={1}>
                    <FormattedMessage id="sharedScreen.addRegistrationPhoto" />
                  </Box>
                  <ImageChooser
                    variant="square"
                    defaultFile={registration}
                    onImageSelected={(file) =>
                      handleAttachmentSelection("registration_photo", file)
                    }
                    label={intl.formatMessage({
                      id: "sharedScreen.addRegistrationPhoto",
                    })}
                  />
                  {formik.touched.registration_photo &&
                    formik.errors.registration_photo && (
                      <FormHelperText className="errorWrapper">
                        {formik.errors.registration_photo}
                      </FormHelperText>
                    )}
                </Box>
                <Box mb={2}>
                  <Box component="span" display="block" mb={1}>
                    <FormattedMessage id="sharedScreen.addTaxPayerPhoto" />
                  </Box>
                  <ImageChooser
                    variant="square"
                    defaultFile={taxPapers}
                    onImageSelected={(file) =>
                      handleAttachmentSelection("tax_payer_photo", file)
                    }
                    label={intl.formatMessage({
                      id: "sharedScreen.addTaxPayerPhoto",
                    })}
                  />
                  {formik.touched.tax_payer_photo &&
                    formik.errors.tax_payer_photo && (
                      <FormHelperText className="errorWrapper">
                        {formik.errors.tax_payer_photo}
                      </FormHelperText>
                    )}
                </Box>
                <Box mb={2}>
                  <Box component="span" display="block" mb={1}>
                    <FormattedMessage id="sharedScreen.addBankAccountPhoto" />
                  </Box>
                  <ImageChooser
                    variant="square"
                    defaultFile={bankAccount}
                    onImageSelected={(file) =>
                      handleAttachmentSelection("id_bank_photo", file)
                    }
                    label={intl.formatMessage({
                      id: "sharedScreen.addBankAccountPhoto",
                    })}
                  />
                  {formik.touched.id_bank_photo &&
                    formik.errors.id_bank_photo && (
                      <FormHelperText className="errorWrapper">
                        {formik.errors.id_bank_photo}
                      </FormHelperText>
                    )}
                </Box>
              </Box>
            </Grid>
          </Grid>
          <Grid container spacing={2}>
            <Grid item sm={12} className={classes.formWrapper}>
              <Box ml={1} mr={3} mt={2} style={{ width: "100%" }}>
                <Box
                  mt={4}
                  display="flex"
                  alignItems="center"
                  justifyContent="flex-start"
                >
                  <Box width={100}>
                    <InputButton
                      color="secondary"
                      fullWidth
                      size="medium"
                      variant="contained"
                      type="submit"
                      disabled={formik.isSubmitting}
                    >
                      <FormattedMessage id="sharedScreen.update" />
                    </InputButton>
                  </Box>
                  {formik.isSubmitting ? (
                    <Box component="span" ml={4} mt={1} display="inline-block">
                      <CircularProgress
                        color="secondary"
                        disableShrink={false}
                        size={20}
                        thickness={4}
                      />
                    </Box>
                  ) : (
                    <></>
                  )}
                  {formik.errors ? (
                    <Typography
                      variant="h6"
                      component="h6"
                      color="error"
                      style={{ paddingLeft: "14px" }}
                    >
                      {genericError()}
                    </Typography>
                  ) : (
                    <></>
                  )}
                </Box>
              </Box>
            </Grid>
          </Grid>
        </form>
      </>
    );
  };

  useEffect(() => {
    loadBusinessCategories();
  }, []);

  return (
    <>
      <Modal
        className={classes.modal}
        open={zoomed}
        onClose={() => setZoomed(false)}
      >
        <img className={classes.zoomed} alt="document" src={zoomImage} />
      </Modal>
      <Grid className={classes.main} container spacing={2}>
        <Grid
          item
          container
          xs={12}
          sm={12}
          lg={12}
          justify="space-between"
          direction="row"
        >
          <Typography
            className={classes.formSectionTitle}
            variant="h4"
            component="h4"
          >
            {editing ? (
              <FormattedMessage id="sharedScreen.edit" />
            ) : (
              <FormattedMessage id="sharedScreen.overview" />
            )}
          </Typography>
          <InputButton
            color="secondary"
            variant="outlined"
            onClick={(_) => setEditing(!editing)}
          >
            {editing ? (
              <FormattedMessage id="sharedScreen.cancel" />
            ) : (
              <FormattedMessage id="sharedScreen.edit" />
            )}
          </InputButton>
        </Grid>
        {editing ? renderEditingContent() : renderContent()}
      </Grid>
    </>
  );
};
